/**
 * Permission levels matching backend PermissionLevel enum.
 * Higher values include all lower-level permissions.
 */
export enum PermissionLevel {
  /** No access - module hidden, API returns 403. */
  None = 0,
  /** View-only - can view data and export. No create/edit/delete. */
  Read = 1,
  /** Operational - Read + Create + Edit. Cannot delete. */
  Write = 2,
  /** Full control - Write + Delete + Manage all items, configure module settings. */
  Admin = 3,
}

/**
 * Application module constants matching backend Modules class exactly.
 * These are code constants, not stored in a database table.
 */
export class Modules {
  static readonly Machinery = "Machinery";
  static readonly Servicing = "Servicing";
  static readonly Inventory = "Inventory";
  static readonly Trading = "Trading";
  static readonly PartnerHub = "PartnerHub";
  static readonly Catalog = "Catalog";
  static readonly Settings = "Settings";
  static readonly Users = "Users";
  static readonly Notifications = "Notifications";
  static readonly Maintenance = "Maintenance";
  static readonly Midas = "Midas";

  static readonly All = [
    Modules.Machinery,
    Modules.Servicing,
    Modules.Inventory,
    Modules.Trading,
    Modules.PartnerHub,
    Modules.Catalog,
    Modules.Settings,
    Modules.Users,
    Modules.Notifications,
    Modules.Maintenance,
    Modules.Midas,
  ];
}
